import PropTypes from 'prop-types';
import { values } from 'ramda';

export const PUBLICATION = {
  ACTIVITY_REPORT: 'activity-report',
  SOCIAL_REPORT: 'social-report',
  THEME_MEMENTO: 'theme-memento',
  STUDY_BAROMETRE: 'study-barometre',
  WHITE_PAPER: 'white-paper',
  POSTEO_BOOK: 'posteo-book',
  POSTEO_MAGAZINE: 'posteo-magazine',
};

export const PublicationType = PropTypes.oneOf(values(PUBLICATION));
